export enum AnimationDuration {
  SHORT = '200ms'
}

export enum AnimationScaleRatio {
  LARGE_PARTIAL_SCALE = '0.7'
}

export enum AnimationDirection {
  LEFT = 'left',
  RIGHT = 'right'
}

export const ANIMATION_TRANSLATE_Y = '-106%';
